import React from 'react'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom'
import { API_URL, SENTRY_DSN } from './config'
import pkg from '../package.json'

Sentry.init({
  dsn: SENTRY_DSN,
  debug: true,
  release: `v${pkg.version}`,
  integrations: [
    new BrowserTracing({
      tracingOrigins: ['localhost', API_URL.replace(/^https?:\/\//, ''), /^\//],
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      )
    })
  ],
  tracesSampleRate: 1.0
})
